import React from 'react';
const PL = [
  { category: 'Revenue', items: [
    { name: 'Grocery Sales', current: 385000, prior: 362000 },
    { name: 'Deli & Prepared Foods', current: 48200, prior: 44800 },
    { name: 'Bakery Sales', current: 22400, prior: 20100 },
    { name: 'Online Orders', current: 18600, prior: 12400 },
  ]},
  { category: 'Cost of Goods Sold', items: [
    { name: 'Wholesale Purchases', current: 268000, prior: 254000 },
    { name: 'Spoilage & Shrinkage', current: 8200, prior: 9400 },
    { name: 'Packaging & Supplies', current: 3400, prior: 3200 },
  ]},
  { category: 'Operating Expenses', items: [
    { name: 'Payroll & Benefits', current: 82000, prior: 79000 },
    { name: 'Rent & Utilities', current: 18500, prior: 18500 },
    { name: 'Equipment & Maintenance', current: 4200, prior: 5800 },
    { name: 'Marketing', current: 3600, prior: 2800 },
    { name: 'Insurance', current: 4800, prior: 4800 },
    { name: 'Janitorial Supplies', current: 2100, prior: 2400 },
  ]},
];
function fmt(n) { return (n < 0 ? '-' : '') + '$' + Math.abs(n).toLocaleString(); }
export default function ProfitLossPage() {
  const rev = PL[0].items.reduce((a, i) => a + i.current, 0);
  const cogs = PL[1].items.reduce((a, i) => a + i.current, 0);
  const opex = PL[2].items.reduce((a, i) => a + i.current, 0);
  const net = rev - cogs - opex;
  return (
    <div className="page-body" style={{ padding: 24 }}>
      <div style={{ marginBottom: 24 }}>
        <h1 style={{ color: 'var(--text)', fontSize: 26, fontWeight: 700, margin: '0 0 4px' }}>Profit & Loss</h1>
        <p style={{ color: 'var(--text-muted)', fontSize: 14, margin: 0 }}>Monthly P&L statement — February 2026</p>
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 16, marginBottom: 24 }}>
        {[{ label: 'Revenue', value: fmt(rev), color: '#16A34A' }, { label: 'COGS', value: fmt(cogs), color: '#EF4444' }, { label: 'Expenses', value: fmt(opex), color: '#F59E0B' }, { label: 'Net Income', value: fmt(net), color: net >= 0 ? '#16A34A' : '#EF4444' }].map((s, i) => (
          <div key={i} style={{ padding: 20, background: 'var(--card)', borderRadius: 12, border: '1px solid var(--border)' }}>
            <div style={{ color: 'var(--text-muted)', fontSize: 11, fontWeight: 600, textTransform: 'uppercase', marginBottom: 8 }}>{s.label}</div>
            <div style={{ color: s.color, fontSize: 24, fontWeight: 700 }}>{s.value}</div>
          </div>
        ))}
      </div>
      <div style={{ background: 'var(--card)', borderRadius: 12, border: '1px solid var(--border)', overflow: 'auto' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead><tr>{['Line Item', 'Current Month', 'Prior Month', 'Change'].map(h => (
            <th key={h} style={{ padding: '12px 16px', textAlign: h === 'Line Item' ? 'left' : 'right', fontSize: 11, fontWeight: 600, textTransform: 'uppercase', color: 'var(--text-muted)', borderBottom: '1px solid var(--border)', background: 'rgba(15,23,42,0.3)' }}>{h}</th>
          ))}</tr></thead>
          <tbody>{PL.map(sec => (
            <React.Fragment key={sec.category}>
              <tr><td colSpan={4} style={{ padding: '12px 16px', color: 'var(--text)', fontSize: 14, fontWeight: 700, background: 'rgba(15,23,42,0.15)', borderBottom: '1px solid var(--border)' }}>{sec.category}</td></tr>
              {sec.items.map(item => {
                const chg = ((item.current - item.prior) / item.prior * 100).toFixed(1);
                const up = item.current >= item.prior;
                return (
                  <tr key={item.name} style={{ borderBottom: '1px solid var(--border)' }}>
                    <td style={{ padding: '10px 16px 10px 32px', color: 'var(--text-secondary)', fontSize: 13 }}>{item.name}</td>
                    <td style={{ padding: '10px 16px', color: 'var(--text)', fontSize: 13, fontWeight: 600, textAlign: 'right' }}>{fmt(item.current)}</td>
                    <td style={{ padding: '10px 16px', color: 'var(--text-muted)', fontSize: 13, textAlign: 'right' }}>{fmt(item.prior)}</td>
                    <td style={{ padding: '10px 16px', textAlign: 'right' }}><span style={{ color: sec.category === 'Revenue' ? (up ? '#16A34A' : '#EF4444') : (up ? '#EF4444' : '#16A34A'), fontSize: 12, fontWeight: 600 }}>{up ? '+' : ''}{chg}%</span></td>
                  </tr>
                );
              })}
            </React.Fragment>
          ))}</tbody>
        </table>
      </div>
    </div>
  );
}
